import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Locations from "@/pages/Locations";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import AdminApp from "@/admin/AdminApp";
import LocalDentist from "@/pages/LocalDentist";
import Gallery from "@/pages/Gallery";
import NotFound from "@/pages/NotFound";
import { LangProvider } from "@/i18n/LangContext";

const withAuth = (el) => <ClerkAuthProvider>{el}</ClerkAuthProvider>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/contact-me" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/dentist-san-juan-del-sur" element={<LocalDentist id="sjds" key="sjds" />} />
            <Route path="/dentist-managua" element={<LocalDentist id="managua" key="managua" />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Route>
          <Route path="/sign-in/*" element={withAuth(<SignInPage />)} />
          <Route path="/sign-up/*" element={withAuth(<SignUpPage />)} />
          <Route path="/admin/*" element={withAuth(<AdminApp />)} />
        </Routes>
        </LangProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
